import type { AxiosError } from 'axios'
import { AxiosErrorHandler } from '@models/classes/axiosErrorHandler'
import { useUserStore } from '@youandco/stores/userStore'

export const handleApiError = (error: unknown): AxiosErrorHandler => {
  const errorHandler = new AxiosErrorHandler(error as AxiosError)
  if (errorHandler.isLogoutError) {
    useUserStore().setAuthorizationStatus(false)
  }
  return errorHandler
}
